import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getCreditCards, profilePostAction } from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import TextError from "../../components/WraapperComponent/TextError";
import { getUserDetail } from "../../utils/helper";

const CardPopup = ({ closePopup, cardInfo, setListChanged }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const initialValues = {
    nameOncard: cardInfo && cardInfo.ccName,
    cardNumber: cardInfo?.ccNumber ? "*******" + cardInfo.ccNumber : "",
    expirationMonth:
      cardInfo &&
      (cardInfo.ccExpiration.toString().length === 4
        ? cardInfo.ccExpiration.toString().substr(0, 2)
        : "0" + cardInfo.ccExpiration.toString().substr(0, 1)),
    expirationYear: cardInfo && cardInfo.ccExpiration.toString().substr(-2),
    creditCardNickname: cardInfo && cardInfo.name,
  };

  const validationSchema = Yup.object({
    nameOncard: Yup.string().nullable().required("This field is required"),
    cardNumber: cardInfo?.ccNumber
      ? Yup.string().nullable().required("This field is required")
      : Yup.string()
          .nullable()
          .min(12, "Credit card number be between 12 and 19 digits long")
          .max(19, "Credit card number be between 12 and 19 digits long")
          .matches(/^[0-9]*$/, "Credit card number is invalid")
          .required("This field is required"),
    expirationMonth: Yup.string()
      .nullable()
      .max(2, "Expiration month be 2 digits long")
      .matches(/^([1-9]|[0][1-9]|[1][0-2])$/, "Expiration month is invalid")
      .required("This field is required"),
    expirationYear: Yup.string()
      .nullable()
      .min(2, "Expiration year be 2 digits long")
      .max(2, "Expiration year be 2 digits long")
      .matches(/^[0-9]*$/, "Expiration year is invalid")
      .required("This field is required"),
    creditCardNickname: Yup.string().nullable(),
  });

  const onSubmit = (values) => {
    let currentMonth = new Date().getMonth() + 1;

    const data = {
      ccName: values.nameOncard,
      ccNumber: cardInfo?.ccNumber ? cardInfo?.ccNumber : values.cardNumber,
      ccExpMonth: values.expirationMonth,
      ccExpYear: values.expirationYear,
      nickname:
        values.creditCardNickname === "" ? null : values.creditCardNickname,
      expiration: values.expirationMonth + values.expirationYear,
      cc_id: cardInfo && cardInfo.cc_id,
    };
    var actionName =
      cardInfo != null ? "userEditCreditCard" : "userAddCreditCard";
    var params = {
      params: {
        action: actionName,
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        dispatch(
          getCreditCards(() => {
            setListChanged(true);
          })
        );
        closePopup();
      })
    );
  };
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Payment information</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
            }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Name on card"
                        name="nameOncard"
                        handleBlur={handleBlur}
                        hasError={errors.nameOncard && touched.nameOncard}
                      />
                    </div>

                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Credit card number"
                        name="cardNumber"
                        maxLength={19}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value.length < 20) {
                            setFieldValue("cardNumber", e.target.value);
                          }
                        }}
                        handleBlur={handleBlur}
                        disabled={cardInfo?.ccNumber}
                        hasError={errors.cardNumber && touched.cardNumber}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="number"
                        label="* Expiration Month"
                        name="expirationMonth"
                        maxLength={2}
                        onChange={(e) => {
                          if (e.target.value.length < 3) {
                            setFieldValue("expirationMonth", e.target.value);
                          }
                        }}
                        handleBlur={handleBlur}
                        hasError={
                          errors.expirationMonth && touched.expirationMonth
                        }
                      />
                    </div>

                    <div className="col-sm-6">
                      <div
                        className={
                          errors.expirationYear && touched.expirationYear
                            ? "form-group star has-error"
                            : "star form-group"
                        }
                      >
                        <span className="input-focus"></span>
                        <label htmlFor="expirationYear">
                          * expiration Year
                        </label>
                        <div className="input year-field">
                          <label className="year-text">20-</label>
                          <input
                            type="number"
                            value={values.expirationYear}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              if (e.target.value.length < 3) {
                                setFieldValue("expirationYear", e.target.value);
                              }
                            }}
                            maxLength={2}
                            className="form-control"
                            name="expirationYear"
                          />
                        </div>
                      </div>
                      <ErrorMessage
                        component={TextError}
                        name="expirationYear"
                      />
                    </div>
                  </div>
                  <div className="submit-section mt-2">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default CardPopup;
